export const DESKTOP_TEXT_WIDTH = 350;

export const DESKTOP_MIN_POST_HEIGHT = 400;

export const POST_TEXT_SCROLL_OFFET = 5;
